module.exports = __webpack_public_path__ + "img/P36-zh.8c13fd2a.png";